<template>
  <div class="border-b pb-4">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="text-1rem">
      <el-breadcrumb-item>{{ $t(first) }}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="second">{{ $t(second) }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
import { watchEffect, ref } from "@vue/composition-api";
export default {
  props: { data: String },
  setup(props, ctx) {
    const first = ref();
    const second = ref();
    const obj = {
      // 帮助中心: [
      //   "常见问题",
      //   "订单问题",
      //   "物流问题",
      //   "优惠券问题",
      //   "退货与售后问题",
      // ],
      服务声明: ["交易规则", "用户使用协议", "隐私政策", "免责声明",'账号注销'],
      关于我们: ["关于花易宝", "新闻资讯"],
    };
    watchEffect(() => {
      if (props.data) {
        second.value = props.data;
        const res1 = Object.values(obj)
          .map((item) => item.includes(second.value))
          .indexOf(true);
        const res2 = Object.keys(obj);
        first.value = res2[res1];
      }

    });
    watchEffect(() => {
      const tag = ctx.root.$route.query.tag
      if (tag == 'feedback') {
        first.value = '意见反馈'
        second.value = ''
      } else if (tag == 'callus') {
        first.value = '联系我们'
        second.value = ''
      }
    })

    return { first, second };
  },
};
</script>
<style></style>
